import React from 'react';
export function Navbar() {
  return <nav className="w-full py-6 px-6 md:px-12 absolute top-0 z-50 flex justify-center md:justify-start" data-id="element-148">
      <div className="text-gold-400 font-serif tracking-widest text-sm md:text-base uppercase font-semibold opacity-90" data-id="element-149">
        El Código de la Riqueza Latina
      </div>
    </nav>;
}